<template>
  <div class="business-classes">
    <common-layout>
      <div slot="header">
        <h3>行业专家</h3>
      </div>
      <div slot="container">
        <div class="business-classes.header">
          <el-button class="business-person.addBtn" @click="$router.go(-1)"
            >返回上一页</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623aa2; border: none"
            >新增</el-button
          >

          <section class="flex-start">
            <span style="margin: 0 0px 0 15px; width: 5em">姓名</span>
            <el-input
              v-model="value"
              placeholder="请输入要搜索的姓名"
              @change="search"
            >
            </el-input>
            <span style="margin: 0 0px 0 15px; width: 8em">行业领域</span>

            <el-select
              v-model="tech_field_select"
              style="width: 100%"
              @change="search"
              clearable
            >
              <el-option
                v-for="item in tech_fields"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </section>
        </div>
        <div class="business-classes.table">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="headerStyle"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="90"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sex"
              label="性别"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="major"
              label="专业"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="techField"
              label="行业领域"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="workCompany"
              label="工作单位"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="techTitle"
              label="技术职称"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="curLive"
              label="住址"
              :formatter="formatter"
              align="center"
            >
            </el-table-column>
            <el-table-column align="left" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  v-show="scope.row.course_status == 4 || !scope.row.enroll_num"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="行业专家"
      :visible.sync="dialogVis"
      width="40%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="form" :rules="rules" label-width="80px" ref="form">
        <div class="form-title">基本信息</div>
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="专家姓名" prop="name">
                <el-input v-model="form.name" placeholder="专家姓名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-col :span="12" class="business-classes.form">
            <el-form-item label="头像">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="form.headImgUrl"
                  :src="imgUrl + form.headImgUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-row>
            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <el-select v-model="form.sex" style="width: 100%" 　clearable>
                  <el-option
                    v-for="item in sexs"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="行业领域" prop="techField">
                <el-select
                  v-model="form.techField"
                  style="width: 100%"
                  　clearable
                >
                  <el-option
                    v-for="item in tech_fields"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="毕业学校" prop="school">
                <el-input
                  v-model="form.school"
                  placeholder="毕业学校"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="12">
            <el-form-item label="专业" prop="major">
              <el-input v-model="form.major" placeholder="专业"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="学历" prop="edu">
              <el-input v-model="form.edu" placeholder="学历"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="工作单位" prop="workCompany">
              <el-input
                v-model="form.workCompany"
                placeholder="工作单位"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="技术职称" prop="techTitle">
              <el-input
                v-model="form.techTitle"
                placeholder="技术职称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="现居地址" prop="curLive">
          <el-select v-model="form.curLive" style="width: 100%" 　clearable>
            <el-option
              v-for="item in cur_lives"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="form-title">其他</div>

        <el-form-item label="专家简介" prop="intro">
          <editor
            v-model="form.intro"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            :placeholderText="'专家简介...'"
          ></editor>
        </el-form-item>
        <el-form-item label="研究方向" prop="researchDir">
          <editor
            v-model="form.researchDir"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            :placeholderText="'研究方向...'"
          ></editor>
        </el-form-item>
        <el-form-item label="研究成果" prop="researchGain">
          <editor
            v-model="form.researchGain"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            :placeholderText="'研究成果...'"
          ></editor>
        </el-form-item>
        <el-form-item label="科研项目" prop="techProject">
          <editor
            v-model="form.techProject"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            :placeholderText="'科研项目...'"
          ></editor>
        </el-form-item>
        <el-form-item label="论文著作" prop="pagerWork">
          <editor
            v-model="form.pagerWork"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            :placeholderText="'论文著作...'"
          ></editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitEvent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import editor from "../../components/tinymce-editor/tinymce-editor";

export default {
  components: {
    editor,

    CommonLayout,
  },
  data() {
    return {
      tech_field_select: "",
      is_submit: true,
      operate: "add",
      cur_lives: [
          {id: '1', label: "省内"},
          {id: '2', label: "省外"}
      ],
      sexs: [
          {id: '1', label: "男"},
          {id: '2', label: "女"}
      ],
      tech_fields: [
        // 1-节能环保 2-清洁生产 3-清洁能源 4-循环农业 5-中医中药 6-文化旅游 7-通道物流 8-数据信息 9-军民融合 10-先进制造'
        {id: '1', label: "节能环保"},
          {id: '2', label: "清洁生产"},
          {id: '3', label: "清洁能源"},
          {id: '4', label: "循环农业"},
          {id: '5', label: "中医中药"},
          {id: '6', label: "文化旅游"},
          {id: '7', label: "通道物流"},
          {id: '8', label: "数据信息"},
          {id: '9', label: "军民融合"},
          {id: '10', label: "先进制造"}
      ],
      value: "",
      status: "",
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      total: 20,
      current_page: 1,
      per_page: 10,
      dialogVis: false,
      tableData: [
        { course_id: "张三", course_phase: "中级", course_status: "第一期" },
        { course_id: "张三", course_phase: "中级", course_status: "第一期" },
        { course_id: "张三", course_phase: "中级", course_status: "第一期" },
        { course_id: "张三", course_phase: "中级", course_status: "第一期" },
        { course_id: "张三", course_phase: "中级", course_status: "第一期" },
      ],
      form: {
        name: "",
        sex: "",
        headImgUrl: "",
        major: "",
        school: "",
        techField: "",
        edu: "",
        workCompany: "",
        techTitle: "",
        curLive: "",
        intro: "",
        researchDir: "",
        researchGain: "",
        techProject: "",
        pagerWork: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        curLive: [
          {
            message: "请选择现居地址",

            required: true,
            trigger: "change",
          },
        ],
        major: [
          {
            required: true,
            message: "请填写专业",
            trigger: "blur",
          },
        ],
        edu: [
          {
            required: true,
            message: "请填写学历",
            trigger: "blur",
          },
        ],
        workCompany: [
          {
            required: true,
            message: "请填写工作单位",
            trigger: "blur",
          },
        ],
        techTitle: [
          {
            required: true,
            message: "请填写技术职称",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        techField: [
          {
            required: true,
            message: "请选择行业领域",
            trigger: "change",
          },
        ],
        school: [
          {
            required: true,
            message: "请填写毕业学校",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.ResetForm({ value: this.form });

    this.getOptions();
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.form.headImgUrl = res.data.store_result;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG / PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 列表数据回填
    formatter(row, column, cellValue, index) {
      switch (column.property) {
        case "curLive": {
          let str = "";
          if (cellValue == 1) {
            str = "省内";
          }
          if (cellValue == 2) {
            str = "省外";
          }
          return str;
          break;
        }
        case "sex": {
          let str = "";
          if (cellValue == 1) {
            str = "男";
          }
          if (cellValue == 2) {
            str = "女";
          }
          return str;
          break;
        }
        // 技术领域: 1-节能环保 2-清洁生产 3-清洁能源 4-循环农业 5-中医中药 6-文化旅游 7-通道物流 8-数据信息 9-军民融合 10-先进制造',
        case "techField": {
          let str = "";
          if (cellValue == 1) {
            str = "节能环保";
          }else if (cellValue == 2) {
            str = "清洁生产";
          }else if (cellValue == 3) {
            str = "清洁能源";
          }else if (cellValue == 4) {
            str = "循环农业";
          }else if (cellValue == 5) {
            str = "中医中药";
          }else if (cellValue == 6) {
            str = "文化旅游";
          }else if (cellValue == 7) {
            str = "通道物流";
          }else if (cellValue == 8) {
            str = "数据信息";
          }else if (cellValue == 9) {
            str = "军民融合";
          }else if (cellValue == 10) {
            str = "先进制造";
          }
          return str;
          break;
        }

        default: {
          return cellValue;
          break;
        }
      }
    },
    //   获取下拉选择映射

    async getOptions() {


      // const res = await this.http.get("/industry_expert?keyword&tech_field");

      // this.tech_fields = await this.GetOptions(res.data.tech_fields);
      // this.sexs = await this.GetOptions(res.data.sexs);
      // this.cur_lives = await this.GetOptions(res.data.cur_lives);
    },

    search() {
      this.getData(
        "industry_expert?keyword=" +
          this.value +
          "&techField=" +
          this.tech_field_select
      );
    },
    goPhotoList(row) {
      if (row.course_status != 2) {
        this.$message.warning("只有已结束才能录制课程剪影");
      } else {
        this.$router.push({
          path: `/transfer/business/photo?id=${row.id}`,
        });
      }
    },
    add() {
      this.operate = "add";
      this.dialogVis = true;

      this.$refs["form"].resetFields();
      this.form = this.ResetForm({ type: true, name: "form" });
    },
    handleEdit(row) {
      this.operate = "edit";
      this.dialogVis = true;
      row.sex = String(row.sex);
      row.techField = String(row.techField);
      row.curLive = String(row.curLive);
      this.form = Object.assign({}, row);
      this.form.sex += "";
      this.form.techField += "";
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          if (row.enroll_num) {
            this.$message.warning("当前课程已有人报名,禁止删除");
            return true;
          }

          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/voucher/industry-expert/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.ResetSearch(["value", "tech_field_select"]);

                this.getData("industry_expert?page=" + this.current_page);
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    submitEvent() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.operate == "add") {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/voucher/industry-expert/create`, this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.ResetSearch(["value", "tech_field_select"]);
                  this.$message.success("新增成功");
                  this.dialogVis = false;
                  // this.getData("industry_expert");
                  this.search();
                } else {
                  this.is_submit = true;
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          } else {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/voucher/industry-expert/update`, this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.ResetSearch(["value", "tech_field_select"]);

                  this.$message.success("编辑成功");
                  this.dialogVis = false;
                  //   this.getData("industry_expert");
                  this.search();
                } else {
                  this.is_submit = true;
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVis = false;
    },
    handleCurrentChange(val) {
      this.getData(`industry_expert?page=${val}`);
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })

      }
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/industry-expert/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.current_page = res.data.current_page;
        } else {
          this.$message.error("获取数据失败！！");
        }
      });
    },
  },
  mounted() {
    this.getData("industry_expert?keyword&tech_field");
  },
};
</script>

<style lang="scss">
@include component(business-classes) {
  width: 100%;
  height: 100%;
  .form-title {
    width: 100%;
    text-align: left;
    color: #0572a4;
    border-left: 5px solid #0572a4;
    border-bottom: 1px solid #0572a4;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }
  @include part(form) {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }

    section {
      margin-left: 50px;
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
    margin-right: 30px;
  }

  @include part(addBtn) {
    margin-left: 30px;
  }

  @include part(table) {
    margin-top: 30px;
  }
}
</style>
